import React from 'react';
import { Input, InputNumber, Space, Table } from 'antd';

const CommonDataTable = ({ columns, dataSource, loading, tableTitle }) => {
  return (

    <>
      <div>{tableTitle}</div>
      <div className='d-flex justify-content-between mt-5'>
        <div className='d-flex gap-1'>
          <p className='mt-1'>Show</p>
          <div>
            <InputNumber min={1} max={10} defaultValue={3} />
          </div>
          <p className='mt-1'>Entries</p>
        </div>
        <div className='d-flex gap-2'>
          <p className='mt-1'>Search</p>
          <div>
            <Space.Compact>
              <Input defaultValue="" placeholder='Search' />
            </Space.Compact>
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={(record) => record.key || record.id || Math.random()}
        bordered
        pagination={{ pageSize: 10 }}
      />
    </>
  );
};

export default CommonDataTable;
